import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';

/* Pages */
import ThankYouPage from './pages/ThankYouPage';
import DashboardPage from './pages/DashboardPage';
import AddFamilyPage from './pages/AddFamilyPage';
import CouponPage from './pages/CouponPage';
import StandaloneQuestionnaire from './pages/StandaloneQuestionnaire';
import FamilyQuestionnaire from './pages/FamilyQuestionnaire';
import FamilyMemberDetails from './pages/FamilyMemberDetails';
import CampaignCoupons from './pages/CampaignCoupons';
import StatsDashboard from './pages/StatsDashboard';



/* Global Styles */
import './index.css';

/* Captures dynamic slug, saves as pnid, redirects to "/" */
const SlugCapture = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (slug) {
      localStorage.setItem('pnid', slug.slice(-12));
    }
    navigate('/', { replace: true });
  }, [slug, navigate]);

  return null;
};

/* Guard: only renders children if pnid exists in localStorage */
const RequirePnid = ({ children }) => {
  const pnid = localStorage.getItem('pnid');
  if (!pnid) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20vh' }}>
        <h1>404 - Page Not Found</h1>
        <p>Invalid or missing access link.</p>
      </div>
    );
  }
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page — only accessible if pnid exists */}
        <Route path="/" element={<RequirePnid><ThankYouPage /></RequirePnid>} />
            <Route path="/CampaignCoupons" element={<CampaignCoupons />} />

    <Route path="/stats" element={<StatsDashboard />} />

        {/* Dashboard */}
        <Route path="/dashboard" element={<RequirePnid><DashboardPage /></RequirePnid>} />

        {/* Add Family Member */}
        <Route path="/add-family" element={<RequirePnid><AddFamilyPage /></RequirePnid>} />

        {/* Coupon Screen */}
        <Route path="/coupon" element={<RequirePnid><CouponPage /></RequirePnid>} />
    

        {/* Detailed Report */}


        {/* Vitamin D Questionnaire */}
        <Route path="/questionnaire" element={<StandaloneQuestionnaire />} />
        <Route path="/FamilyQuestionnaire" element={<FamilyQuestionnaire />} />


        {/* Family Member Details */}
        <Route path="/family-member-details" element={<FamilyMemberDetails />} />

        {/* Captures domain.com/{slug} → saves pnid → redirects to "/" */}
        <Route path="/:slug" element={<SlugCapture />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
